import React from 'react';
import PropTypes from 'prop-types';

import globalsService from '../../../services/GlobalsService';
import { t } from '../../../services/i18nService';

import styles from './capturedevice.scss';

class CapturedPhoto extends React.PureComponent {
    static propTypes = {
        photo: PropTypes.object,
    };

    constructor(props) {
        super(props);

        this.currentBlob = null;
        this.currentUrl = null;
    }

    componentWillUnmount() {
        this.maybeRevoke();
    }

    maybeRevoke() {
        if (this.currentUrl !== null) {
            window.URL.revokeObjectURL(this.currentUrl);
            this.currentUrl = null;
            this.currentBlob = null;
        }
    }

    render() {
        const newBlob = this.props.photo;

        let className = styles.capturedPhoto;
        let img = null;

        if (newBlob !== this.currentBlob) {
            this.maybeRevoke();

            if (newBlob !== null) {
                this.currentUrl = window.URL.createObjectURL(newBlob);
                this.currentBlob = newBlob;
            }
        }

        const hasPhoto = this.currentUrl !== null;
        const wrapperClassName = (!hasPhoto) ? styles.placeholderWrapper : null;

        if (hasPhoto) {
            img = (
                <img
                    src={this.currentUrl}
                    alt={t('idVerification.captureDevice.capturedPhotoAltText')}
                    className={styles.capturedPhotoImage}
                />
            );
        } else {
            const assetRoot = globalsService.getAssetRoot();
            let webcamGrayPath = 'images/idverification/webcam-gray.svg';

            if (assetRoot) {
                webcamGrayPath = `${assetRoot}/${webcamGrayPath}`;
            }

            className += ` ${styles.placeholder}`;
            img = (
                <img
                    src={webcamGrayPath}
                    alt={t('idVerification.captureDevice.placeholderAltText')}
                    className={styles.placeholderIcon}
                />
            );
        }

        return (
            <div className={className}>
                <div className={wrapperClassName}>
                    {img}
                </div>
            </div>
        );
    }
}

export default CapturedPhoto;
